/* Delecora — wishlist page */
(function () {
  'use strict';

function initWishlistPage() {
  var body = document.getElementById('wlBody');
  if (!body || body.dataset.bound === '1') return;
  body.dataset.bound = '1';

  var bar = document.getElementById('wlBar');
  var countEl = document.getElementById('wlCount');
  var addAll = document.getElementById('wlAddAll');
  var clearBtn = document.getElementById('wlClear');

  var wishlist = window.delecoraWishlist;
  var money = window.delecoraFormatMoney || function (c) { return c; };
  var toast = window.delecoraToast || function () {};
  var CFG = window.Delecora || {};

  var cache = {};

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    var root = (CFG.routes && CFG.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { cache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function badgeFor(p) {
    if (!p.available) return { label: 'Sold out', sale: false };
    var compare = p.compare_at_price;
    if (compare && compare > p.price) return { label: 'Sale', sale: true };
    return null;
  }

  function cardHTML(p) {
    var badge = badgeFor(p);
    var images = p.images || [];
    var main = images[0] || (p.featured_image || '');
    var hover = images[1] || '';
    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    var off = onSale ? Math.round(((p.compare_at_price - p.price) / p.compare_at_price) * 100) : 0;
    var variantId = (p.variants && p.variants[0]) ? p.variants[0].id : '';

    return '' +
      '<article class="prod-card" data-handle="' + esc(p.handle) + '">' +
        '<a class="prod-link" href="' + esc(p.url) + '" aria-label="' + esc(p.title) + '">' +
          '<div class="prod-media">' +
            (badge ? '<span class="prod-badge' + (badge.sale ? ' sale' : '') + '">' + esc(badge.label) + '</span>' : '') +
            '<button class="prod-wish active" type="button" data-wish="' + esc(p.handle) + '" aria-label="Wishlist">' +
              '<svg viewBox="0 0 24 24"><path d="M12 21s-7-4.5-9.5-8.5C.5 9.5 2 6 5.5 6c2 0 3.5 1.2 4.5 2.5C11 7.2 12.5 6 14.5 6 18 6 19.5 9.5 17.5 12.5 15 16.5 12 21 12 21z"/></svg>' +
            '</button>' +
            (main ? '<img class="img-main" src="' + esc(main) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
            (hover ? '<img class="img-hover" src="' + esc(hover) + '" alt="" loading="lazy">' : '') +
            '<div class="prod-quick">' +
              (p.available
                ? '<button class="btn" type="button" data-add="' + esc(variantId) + '">' + esc((CFG.strings && CFG.strings.addToBag) || 'Add to bag') + '</button>'
                : '<button class="btn" type="button" disabled style="opacity:.5">' + esc((CFG.strings && CFG.strings.soldOut) || 'Sold out') + '</button>') +
            '</div>' +
          '</div>' +
          '<div class="prod-info">' +
            (p.type ? '<div class="prod-cat">' + esc(p.type) + '</div>' : '') +
            '<div class="prod-name">' + esc(p.title) + '</div>' +
            '<div class="prod-price">' +
              '<span>' + money(p.price) + '</span>' +
              (onSale ? '<s>' + money(p.compare_at_price) + '</s><span class="off">' + off + '% off</span>' : '') +
            '</div>' +
          '</div>' +
        '</a>' +
      '</article>';
  }

  function emptyHTML() {
    var d = body.dataset;
    return '' +
      '<div class="wl-empty">' +
        '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-7-4.5-9.5-8.5C.5 9.5 2 6 5.5 6c2 0 3.5 1.2 4.5 2.5C11 7.2 12.5 6 14.5 6 18 6 19.5 9.5 17.5 12.5 15 16.5 12 21 12 21z"/></svg>' +
        '<h2>' + esc(d.emptyHeading) + '</h2>' +
        '<p>' + esc(d.emptyBody) + '</p>' +
        '<div class="wl-actions">' +
          '<a class="btn btn-solid" href="' + esc(d.browseUrl) + '">' + esc(d.browseLabel) + '</a>' +
          '<a class="btn btn-outline" href="' + esc(d.categoriesUrl) + '">' + esc(d.categoriesLabel) + '</a>' +
        '</div>' +
      '</div>';
  }

  var loaded = [];

  function render() {
    var handles = wishlist ? wishlist.read() : [];

    if (!handles.length) {
      if (bar) bar.style.display = 'none';
      body.innerHTML = emptyHTML();
      loaded = [];
      return;
    }

    Promise.all(handles.map(fetchProduct)).then(function (products) {
      var items = products.filter(Boolean);
      loaded = items;

      /* Drop handles that no longer resolve to a live product. */
      if (items.length !== handles.length && wishlist) {
        wishlist.write(items.map(function (p) { return p.handle; }));
        wishlist.paintDot();
      }

      if (!items.length) {
        if (bar) bar.style.display = 'none';
        body.innerHTML = emptyHTML();
        return;
      }

      if (bar) bar.style.display = 'flex';
      if (countEl) countEl.textContent = items.length + (items.length === 1 ? ' item saved' : ' items saved');
      body.innerHTML = '<div class="prod-grid">' + items.map(cardHTML).join('') + '</div>';
    });
  }

  if (addAll) {
    addAll.addEventListener('click', function () {
      var available = loaded.filter(function (p) { return p.available && p.variants && p.variants[0]; });
      if (!available.length) { toast('Nothing available to add'); return; }
      var root = (CFG.routes && CFG.routes.cartAdd) || '/cart/add.js';
      fetch(root, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: available.map(function (p) { return { id: p.variants[0].id, quantity: 1 }; })
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          toast(available.length + ' items added to bag');
          window.location.reload();
        })
        .catch(function () { toast('Could not add to bag'); });
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      if (wishlist) { wishlist.write([]); wishlist.paintDot(); }
      render();
      toast('Wishlist cleared');
    });
  }

  document.addEventListener('delecora:wishlist:updated', render);

  render();
}

  initWishlistPage();
  document.addEventListener('shopify:section:load', initWishlistPage);
})();
